import { render } from "./AffiliateEmailsSelect.vue?vue&type=template&id=21e28f68&scoped=true"
import script from "./AffiliateEmailsSelect.vue?vue&type=script&lang=js"
export * from "./AffiliateEmailsSelect.vue?vue&type=script&lang=js"

import "./AffiliateEmailsSelect.vue?vue&type=style&index=0&id=21e28f68&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e28f68"]])

export default __exports__